import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component, cloneElement } from 'react';
import { createPortal } from 'react-dom';
import uuid from '../utils/uuid';
/**
 * Предоставляет в оборачиваемый `Target` методы монтирования/размонтирования в отделную ноду в DOM.
 *
 *  @provideRenderToLayer
 *  class Popup extends Component {
 *
 *    openPopup = () => {
 *      this.popupElement = this.props.renderToLayer(
 *        <div>
 *          <button onClick={this.closePopup}>
 *            Закрыть попап
 *          </button>
 *        </div>
 *      )
 *    }
 *
 *    closePopup = () => {
 *      this.props.unrenderAtLayer(this.popupElement)
 *    }
 *
 *    render() {
 *      return (
 *        <button onClick={this.openPopup}>
 *          Открыть попап
 *        </button>
 *      )
 *    }
 *
 *  }
 *
 * Передает в оборачиваемый компонент следующие props:
 * - renderToLayer(element) - монтирует переданный `element` в отделную ноду
 * - unrenderAtLayer(element) - размонтирует `element`
 */

export default function provideRenderToLayer(Target) {
  var _temp;

  return _temp = /*#__PURE__*/function (_Component) {
    _inherits(ProvideRenderToLayer, _Component);

    var _super = _createSuper(ProvideRenderToLayer);

    function ProvideRenderToLayer() {
      var _this;

      _classCallCheck(this, ProvideRenderToLayer);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      _this.elements = [];
      _this.state = {
        isOpened: false
      };

      _this.renderToLayer = function (element, props) {
        var key = uuid();
        var resultElement = cloneElement(element, _extends({}, props, {
          key: key,
          isOpened: true
        }));

        _this.elements.push(resultElement);

        _this.mountPortal();

        return resultElement;
      };

      _this.unrenderAtLayer = function (element) {
        var elementIndex = _this.elements.indexOf(element);

        if (elementIndex < 0) return Promise.resolve();
        return new Promise(function (resolve) {
          var _containerRef = element.props.containerRef;
          var closedElement = cloneElement(element, {
            isOpened: false,
            containerRef: function containerRef(ref) {
              if (_containerRef) _containerRef(ref);
              resolve(closedElement);
            }
          });
          _this.elements[elementIndex] = closedElement;

          _this.mountPortal();
        }).then(function (closedElement) {
          _this.elements = _this.elements.filter(function (el) {
            return el !== closedElement;
          });
          if (_this.elements.length === 0) _this.unmountPortal();
        });
      };

      return _this;
    }

    _createClass(ProvideRenderToLayer, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.elements = [];
        this.unmountPortal();
      }
    }, {
      key: "getContentContainerNode",
      value: function getContentContainerNode() {
        if (!this.node) {
          this.node = document.createElement('div');
          document.body.appendChild(this.node);
        }

        return this.node;
      }
    }, {
      key: "mountPortal",
      value: function mountPortal() {
        this.setState({
          isOpened: true
        });
      }
    }, {
      key: "unmountPortal",
      value: function unmountPortal() {
        if (this.node) {
          this.setState({
            isOpened: false
          });
          document.body.removeChild(this.node);
          this.node = null;
        }
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(React.Fragment, null, React.createElement(Target, _extends({}, this.props, {
          renderToLayer: this.renderToLayer,
          unrenderAtLayer: this.unrenderAtLayer
        })), this.state.isOpened && createPortal(React.createElement(React.Fragment, null, this.elements), this.getContentContainerNode()));
      }
    }]);

    return ProvideRenderToLayer;
  }(Component), _temp;
}